module.exports = __webpack_public_path__ + "static/media/5DPO19.18ad6254.jpg";